import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import UnauthorisedCounterpartyCriteria, { CounterpartyType } from "./UnauthorisedCounterpartyCriteria";
import { Neo } from "@singularsystems/neo-react";
import { EnumHelper } from "@singularsystems/neo-core";

@NeoReport("UnauthorisedCounterpartyReport", { category: ReportCategory.CombinedReports })
export default class UnauthorisedCounterpartyReport extends Report<UnauthorisedCounterpartyCriteria> {

    constructor() {
        super(UnauthorisedCounterpartyCriteria);
    }

    public renderCriteria() {
        return <div>
             <Neo.FormGroupInline bind={this.criteria.meta.counterpartyType} select={{ items: EnumHelper.asList(CounterpartyType) }} />
        </div>;
    }
}